import { Check } from "lucide-react";
import Tag from "../tag/tag.component";

interface FitStripProps {
  tag: string;
  items: string[];
  fine?: string;
}

// Dark "Confirmed about Fydo today" band: a tag, a two-column checklist of
// facts, and an optional fine-print line.
const FitStrip = ({ tag, items, fine }: FitStripProps) => (
  <div className="mt-8 grid items-start gap-6 rounded-3xl bg-ink p-6 text-white sm:px-8 sm:py-7 lg:grid-cols-[auto_1fr]">
    <Tag className="justify-self-start">{tag}</Tag>
    <ul className="grid gap-2.5 lg:grid-cols-2 lg:gap-x-8">
      {items.map((item) => (
        <li
          key={item}
          className="relative pl-7 text-[15.5px] leading-normal text-white/90"
        >
          <Check
            className="absolute top-[3px] left-0 size-[18px] text-primary"
            strokeWidth={2.4}
            aria-hidden="true"
          />
          {item}
        </li>
      ))}
    </ul>
    {fine && <p className="text-sm text-white/75 lg:col-span-2">{fine}</p>}
  </div>
);

export default FitStrip;
